










import { Component, Vue } from 'vue-property-decorator';
import MapWrapper from './MapWrapper.vue';
import TimelinePanel from './TimelinePanel.vue';
import CurrentEventPanel from './CurrentEventPanel.vue';

@Component({
  components: {
    MapWrapper,
    TimelinePanel,
    CurrentEventPanel,
  },
})
export default class MapCanvas extends Vue {
  configKonva = {
    width: window.innerWidth,
    height: window.innerHeight,
  };

  configLayer = {
    x: 0,
    y: 0,
  };

  addEvents(): void {
    window.addEventListener('resize', () => {
      this.configKonva.width = window.innerWidth;
      this.configKonva.height = window.innerHeight;
    });
  }

  created() {
    this.addEvents();
  }
}
